import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitRound} from '@/model/resource/OrbitRound'

@HttpExclude()
export class OrbitRoundCollection extends ExpansibleCollection<OrbitRound> {
  resource?: IOrbitRoundCollectionResourcesHolder

  @RequestExpose() round: number | null = null
  @RequestExpose() limit: number | null = null
  /** blockchain_version.networkIdentifier: 'neo3/mainnet' | 'neo3/testnet' */
  @RequestExpose() networkIdentifier: string | null = null

  constructor() {
    super(OrbitRound)
  }

  queryAsPage() {
    return this.listOrbitRound()
  }

  async listOrbitRound() {
    return await Request.get(`/client/orbit-round`, {params: this.params})
      .name('listOrbitRound')
      .as(this)
      .getResponse()
  }
}

export interface IOrbitRoundCollectionResourcesHolder {}
